import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import Shell from './Shell.jsx';
// Tailwind, tokens and Support's shared component classes. The header uses them too;
// the file stays in web/src until the CSS entry is split out of Support.
import '../src/styles/app.css';

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <Shell />
  </StrictMode>,
);
